<template>
  <component
    :is="mgnlProps.headingTag"
    v-if="mgnlProps.title && mgnlProps.headingTag"
    :style="{ color: titleColor }"
    class="mb-3"
  >
    {{ mgnlProps.title }}
  </component>
  <ProductList
    :id="pageId"
    :by-categories="categories"
    :operator="operator"
    :by-products="products"
    :by-attributes="attributes"
    :by-skus="skus"
    :page="currentPage"
    :show-categories="false"
    :show-filters="mgnlProps.showFilter"
    :data-ab-id="mgnlProps?.dataABId"
    :is-magnolia="true"
  />
</template>

<script lang="ts" setup>
import { ProductListBuilder, WrapperProps } from './ProductList.model';
import ProductList from '~/components/Category/Magnolia/ProductList.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);
const route = useRoute();

const mgnlProps = ProductListBuilder.build(props);

const { imageLoadType } = toRefs(props);
provide('imageLoadType', imageLoadType?.value ?? 'lazy');

const skus = mgnlProps.switchable?.field === 'skus' ? mgnlProps.switchable?.skus : undefined;

const products
  = mgnlProps.switchable?.field === 'products'
    ? mgnlProps.switchable?.products
        ?.map((product) => {
          let result;

          try {
            result = JSON.parse(product)?.productId;
          }
          catch {
          // ignore error
          }

          return result;
        })
        ?.filter(Boolean)
    : [];

const categories: string[]
  = mgnlProps.switchable?.field === 'categories'
    ? mgnlProps.switchable.categories
        ?.map((product) => {
          let result;

          try {
            result = JSON.parse(product)?.categoryId;
          }
          catch {
          // ignore error
          }

          return result;
        })
        ?.filter(Boolean)
    : [];

const { page = '1' } = import.meta.server
  ? route.query
  : Object.fromEntries(new URLSearchParams(window.location.search));

const multiAttr = mgnlProps.multi?.reduce(
  (acc, curr) => {
    if (!curr.name) {
      return acc;
    }

    if (acc[curr.name]) {
      acc[curr.name].push(curr.value);
      return acc;
    }

    return {
      ...acc,
      [curr.name]: curr.value,
    };
  },
  {} as Record<string, any>,
) || {};

const productAttributes = await JSON.parse(mgnlProps.productAttributes ?? '[]')?.reduce(
  (acc: any, curr: any) => {
    if (!curr.name) {
      return acc;
    }

    if (acc[curr.name]) {
      acc[curr.name].push(curr.value);
      return acc;
    }

    return {
      ...acc,
      [curr.name]: curr.value,
    };
  },
  {} as Record<string, any>,
) || {};

const attributes = {
  ...multiAttr,
  ...productAttributes,
};

if (props.sale) {
  attributes.sale = props.sale;
}

if (props.new) {
  attributes.recent = props.new;
}

if (props.mykik) {
  attributes.mykik = props.mykik;
}

const pageId = `customized-plp-${props.switchable?.['@id']}`;
const currentPage = Number.parseInt(page as string, 10);
const titleColor = magnoliaGetters.getHexColor(mgnlProps?.titleColor);
const operator = mgnlProps.switchable?.operator;
</script>
